import { dispatch } from 'nike-re-framejs';
import { useEffect } from 'react';
import {
    liveMatchIdsPush,
    liveMatchIdsSnapshot,
    sportOverviewMarketsSnapshot,
    sportOverviewMatchSnapshot,
    sportOverviewPush,
    sportOverviewTournamentSnapshot
} from './handlers';
import { PUSH_PATHS } from '../../paths';
import { subscribePath, unsubscribePath } from '../../pushSubscriptions';

export function useActiveMatchIdsPush() {
    useEffect(() => {
        const path = PUSH_PATHS.matches();
        subscribePath(path, {
            onSnapshot: data => dispatch(liveMatchIdsSnapshot(data)),
            onMessage: data => dispatch(liveMatchIdsPush(data))
        });
        return () => unsubscribePath(path);
    }, []);
}

export function useSportOverviewMarketsPush(sportCode: string) {
    useEffect(() => {
        const path = PUSH_PATHS.sportOverviewMarkets(sportCode);
        subscribePath(path, {
            onSnapshot: data => dispatch(sportOverviewMarketsSnapshot(sportCode, data)),
            onMessage: data => dispatch(sportOverviewPush(sportCode, data))
        });
        return () => unsubscribePath(path);
    }, [sportCode]);
}

export function useSportOverviewTournamentPush(sportCode: string, tournamentId: string) {
    useEffect(() => {
        const path = PUSH_PATHS.sportOverviewTournament(sportCode, tournamentId);
        subscribePath(path, {
            onSnapshot: data => dispatch(sportOverviewTournamentSnapshot(sportCode, data)),
            onMessage: data => dispatch(sportOverviewPush(sportCode, data))
        });
        return () => unsubscribePath(path);
    }, [sportCode, tournamentId]);
}

export function useSportOverviewMatchPush(sportCode: string, matchId: string) {
    useEffect(() => {
        const path = PUSH_PATHS.sportOverviewMatch(sportCode, matchId);
        subscribePath(path, {
            onSnapshot: data => dispatch(sportOverviewMatchSnapshot(sportCode, data)),
            onMessage: data => dispatch(sportOverviewPush(sportCode, data))
        });
        return () => unsubscribePath(path);
    }, [sportCode, matchId]);
}
